import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Modal from "react-bootstrap/lib/Modal";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

function dateFormat(cell) {
  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{cell.toDateString()}</font>
  else
    return 'NA';
}
function columnClassFormat(cell, row) {
  if (row.emailIdProfessional == null) {
    return 'brown'
  }
  else
    return 'green';
}

class NewJoinerTable extends React.Component {

  constructor() {
    super();
    this.state = {flag: {}, open: false, emailId: null, employee: {}, error: "", url: null};
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({open: false, url: null});
  }

  open(row) {
    this.setState({open: true, employee: row, emailId: row.emailIdProfessional});
  }

  componentDidMount() {
    let flag = new Object();
    console.log(this.props.data);
    this.props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  componentWillReceiveProps(props) {

    let flag = new Object();
    console.log(props.data);
    props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  render() {
    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    console.log(this.state.flag);
    return (
      <div>
        <BootstrapTable exportCSV={true} search={true}
                        headerStyle={{
                          borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
                          , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
                        }}
                        striped
                        options={options}
                        pagination
                        data={this.props.data}>
          <TableHeaderColumn hidden={true} isKey={true} dataField="id">Id</TableHeaderColumn>
          <TableHeaderColumn hidden={false} width={50} dataFormat={(cell, row)=> {
            return <img
              onClick={()=> {
                this.open(row);

              }}
              src="/public/images/edit.png"/>
          }} dataField="id">Id</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             filter={ {type: 'TextFilter', placeholder: 'EmpId'} }
                             dataField="empId">EmpId</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             filter={ {type: 'TextFilter', placeholder: 'Name'} }
                             dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: this.props.constants.locationFilter, placeholder: 'Location'} }
            dataField="location">Location</TableHeaderColumn>
          <TableHeaderColumn
            dataSort={true}
            filter={ {type: 'SelectFilter', options: this.props.constants.verticalFilter, placeholder: 'Verticals'} }
            dataField="vertical">Vertical</TableHeaderColumn>
          <TableHeaderColumn
            columnClassName={columnClassFormat}
            dataSort={true}
            filter={ {type: 'TextFilter', placeholder: 'Email Id'} }
            dataField="emailIdProfessional">Email Id</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'TextFilter', placeholder: 'Assets'} }
            dataField="assets">Assets</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter',options: {".com":".com",".co.in":".co.in"}, placeholder: 'domain'} }
            dataField="mailDomain">Mail Domain</TableHeaderColumn>

          <TableHeaderColumn
            filter={ {type: 'TextFilter', delay: 0, placeholder: 'Date of Joining'} }
            dataFormat={dateFormat} dataField="joiningDate">Date Of Joining</TableHeaderColumn>

        </BootstrapTable>


        <Modal
          bsSize="medium"
          show={this.state.open} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Email Id</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{fontSize: '15'}}>
              Employee Id: {this.state.employee.empId} &nbsp;&nbsp;Name: {this.state.employee.name}&nbsp;&nbsp;
              Domain: {this.state.employee.mailDomain}

            </div>
            <TextField name="emailId"
                       type="email"
                       fullWidth={true}
                       defaultValue={this.state.employee.emailIdProfessional}
                       errorText={this.state.error}
                       onBlur={(event)=> {
                         if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value))
                           this.setState({emailId: event.target.value, error: ""})
                         else this.setState({error: "InvalidEmailId", emailId: event.target.value})
                       }}
                       hintText="Professional Email Id" floatingLabelText="Email Id"/>
            <br/><br/>
            <a >Login into accounts.quikr.com, if logged out.</a>
            <br/>

            <iframe width={'100%'} height={'250px'} src="https://accounts.quikr.com"></iframe>

            <button
              onClick={()=> {
                let requestObject = new Object();
                Object.assign(requestObject, this.state.employee);
                if (this.state.error == "") {
                  requestObject.email = this.state.emailId;
                  let params = {
                    name: this.state.employee.name,
                    email: this.state.emailId,
                    mobile: this.state.employee.contactNo,
                    type: 1,
                    empId: this.state.employee.empId,
                    redirectUrl: "https://hrms.quikrcorp.com",
                    groupIds: "27,827,35",
                  };
                  let urlParameters = Object.keys(params).map((i) => i + '=' + params[i]).join('&');
                  //this.setState({url: "https://accounts.quikr.com/identity/v1/register?"+urlParameters.substring(0,urlParameters.length-1)});
                  axios.post(process.env.REQ_URL + "/onBoarding/saveEmailId", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                    this.close();
                    this.props.refresh();
                    window.open("https://accounts.quikr.com/identity/v1/register?" + urlParameters);
                    toastr.success("Data updated")

                  }).catch((err)=> {
                    toastr.error("Error Occurred");

                  });


                  /* axios.get("https://accounts.quikr.com/identity/v1/register?",{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'},params: {
                   name: this.state.employee.name,
                   email: this.state.emailId,
                   type: 1,
                   empId: this.state.employee.empId,
                   redirectUrl: "https://hrms.quikrcorp.com/#/1/it/onBoarding",
                   groupIds: 27,
                   }}).then((response)=>{
                   debugger;
                   console.log("IT WORKED");
                   }).catch((error)=>{
                   console.log("Error");
                   });*/

                }
              }}
              className="btn btn-default btn-block">Save
            </button>
            &nbsp;
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

NewJoinerTable.propTypes = {};

export default NewJoinerTable;





/** WEBPACK FOOTER **
 ** ./src/feature/it/OnBoarding/NewJoinerTable.js
 **/